import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { Router } from '@angular/router';
import { BackendApiService } from './services/backend-api.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild {

  constructor(public router: Router, private service: BackendApiService) { }

  canActivate() {
    const userStatus = localStorage.getItem('loginStatus');
    if (userStatus !== 'no') {

    } else {
      this.router.navigate(['/apps']);
      this.service.openSnackBar('You need to login first.', '');
    }
    return true;
  }

  canActivateChild() {
    return true;
  }

}